/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartNoShipping_item$ref = any;
type CartPrice_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartPriceTable_item$ref: FragmentReference;
export type CartPriceTable_item = {|
  +isFurniture: ?boolean,
  +pricing: ?{|
    +purchasable: ?any
  |},
  +$fragmentRefs: CartPrice_item$ref & CartNoShipping_item$ref,
  +$refType: CartPriceTable_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartPriceTable_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartPrice_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartNoShipping_item",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isFurniture",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPricing",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "purchasable",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '54801b031b41037e9c930a1bce2d17a2';
module.exports = node;
